import { FC } from 'react';
import { CatIconShopFilled } from '@blocks-react/components/Icons/ShopFilled';
import { CatBadge } from '@blocks-react/components/Badge';
import { HeaderCartProps } from './types';
import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import { Conditional } from '../../common';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';

export const HeaderCart: FC<HeaderCartProps> = ({
  cartItems,
  handleDrawerProps,
  id,
  isCurrent,
  title,
  redirectionLink
}) => (
  <HeaderNavItem
    aria-label={title}
    data-testid="cat-header-cart-icon"
    id={id}
    isCurrent={isCurrent}
    title={title}
    href={redirectionLink}
    role="menu"
    {...handleDrawerProps}
    data-track-event={MAIN_NAV_TRACK.EVENT}
    data-track-attr-nltext={MAIN_NAV_TRACK.SHOPPING_CART_TEXT}
    data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
  >
    <span className="m-0">
      <Conditional test={cartItems === '...' || (cartItems as number) > 0}>
        <CatBadge
          position="top-right"
          text={cartItems?.toString()}
          variant="brand"
          data-testid="cat-header-cart-badge"
        />
      </Conditional>
      <CatIconShopFilled />
    </span>
  </HeaderNavItem>
);
